import React, { useEffect, useState } from "react";
import { useLanguage } from "../languageContext";
import translations from "../translation.json";
import { format } from "date-fns";
import * as XLSX from "xlsx";
const FollowUp = ({ isDarkMode, appointments, getDataByDate, eventDates }) => {
  const { language } = useLanguage();
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (appointments && appointments.length > 0) {
      setSelectedDate(appointments[0]?.appointment_date);
    }
  }, [appointments]);

  const exportToExcel = () => {
    const selectedData =
      appointments &&
      appointments.length > 0 &&
      appointments.map((event) => ({
        Name:
          (event?.prospective?.first_name ?? "") +
          " " +
          (event?.prospective?.last_name ?? ""),
        "Prospect Source": event?.prospective?.prospect_source,
        Phone: event?.prospective?.phone,
        Date: event.appointment_date,
        Time: event?.appointment_time || "",
        Representative: event?.appointment_rep_user_name || "",
        State: event?.confirmation_status || "",
        Result: event.visit_status || "",
      }));

    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Weeks Data");

    XLSX.writeFile(
      workbook,
      `Follow Up Data ${format(new Date(), "dd/MM/yyyy")}.xlsx`
    );
  };

  return (
    <div className="py-2">
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-8 d-flex align-items-center gap-3">
          <div className="d-flex align-items-center w-100 gap-4">
            <h2
              className={`${isDarkMode ? "darkthead" : ""}`}
              style={{ minWidth: "max-content" }}
            >
              {translations.eventView.followUp[language]}
            </h2>
            <div className="input-group" style={{ width: "100%" }}>
              <span
                className="input-group-text"
                style={{
                  backgroundColor: isDarkMode ? "transparent" : "",
                  color: isDarkMode ? "#ffffff" : "#000000",
                  border: isDarkMode
                    ? "1px solid #495057"
                    : "1px solid #dee2e6",
                }}
              >
                Date
              </span>

              <select
                className="form-select"
                value={selectedDate}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    getDataByDate(
                      { followUpDate: e.target.value },
                      "followUpAppointments"
                    );
                  }
                  setSelectedDate(e.target.value);
                }}
                class={`form-select ${isDarkMode ? "custom-select" : ""}`}
                style={{
                  backgroundColor: isDarkMode ? "transparent" : "",
                  color: isDarkMode ? "#ffffff" : "#000000",
                  border: isDarkMode
                    ? "1px solid #495057"
                    : "1px solid #dee2e6",
                }}
              >
                <option
                  value=""
                  style={{
                    background: isDarkMode ? "#1B1F22" : "",
                    color: isDarkMode ? "#ffffff" : "",
                  }}
                >
                  {translations.dropdown.select[language]}
                </option>
                {eventDates &&
                  eventDates.length > 0 &&
                  eventDates.map((date) => (
                    <option
                      key={date.value}
                      value={date.value}
                      style={{
                        background: isDarkMode ? "#1B1F22" : "",
                        color: isDarkMode ? "#ffffff" : "",
                      }}
                    >
                      {date.label}
                    </option>
                  ))}
              </select>

              {/* <input
                type="date"
                className={`form-control`}
                // style={{
                //   backgroundColor: isDarkMode ? "transparent" : "",
                //   color: isDarkMode ? "#ffffff" : "#000000",
                //   border: isDarkMode
                //     ? "1px solid #495057"
                //     : "1px solid #dee2e6",
                // }}
                // value={new Date().toISOString().split("T")[0]}
                onChange={(e) => {
                  getDataByDate(
                    { followUpDate: e.target.value },
                    "followUpAppointments"
                  );
                }}
              /> */}
            </div>
          </div>
        </div>
        <div className="col-4 d-flex align-items-center justify-content-end gap-1">
          <div className="btn-group" role="group" aria-label="Basic example">
            <button
              type="button"
              className="d-flex btn btn-primary align-items-center admin-btn gap-1"
              // data-bs-toggle="modal"
              // data-bs-target="#modalQuickAdd"
              // fdprocessedid="2rud2c"
              onClick={exportToExcel}
            >
              <i className="bi bi-file-earmark-arrow-down-fill"></i>{" "}
              {translations.commonWords.downloadBtn[language]}
            </button>
          </div>
          {/* <div className="btn-group" role="group" aria-label="Basic example">
            <button
              type="button"
              className="d-flex btn btn-primary align-items-center admin-btn gap-1"
              // data-bs-toggle="modal"
              // data-bs-target="#modalQuickAdd"
              // fdprocessedid="2rud2c"
            >
              <i className="bi bi-send-fill"></i>{" "}
              {translations.commonWords.sendBtn[language]}
            </button>
          </div> */}
        </div>
      </div>
      <div className="d-flex gap-2">
        <div
          className="p-2 rounded-1 w-100"
          style={{
            // boxShadow: "0 0 40px rgba(0, 0, 0, 0.15)",
            minHeight: "330px",
            width: "40%",
            background: isDarkMode ? "" : "rgba(243,243,243)",
          }}
        >
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "column",
              overflowX: "auto",
              maxHeight: "322px",
              minHeight: "322px",
              //   maxHeight: "calc(100vh - 200px)",
            }}
          >
            <table className="align-items-center"
            style={{
                minWidth: "950px", // ✅ force table to be wide enough
                borderCollapse: "collapse",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: "0",
                  zIndex: "999",
                  background: isDarkMode ? "#37474f" : "rgba(243,243,243)",
                }}
              >
                <tr>
                  <th style={{ minWidth: "120px" }}>
                    <p className="fw-bold">
                      {translations.commonFields.name[language]}{" "}
                    </p>
                  </th>
                   <th style={{ minWidth: "100px" }}>
                    <p className="fw-bold">
                      {translations.createProspective.prospectiveSource[language]}
                    </p>
                  </th>
                  <th style={{ minWidth: "100px" }}>
                    <p className="fw-bold">
                      {translations.quickCreationModal.phoneNumber[language]}{" "}
                    </p>
                  </th>
                  <th style={{ minWidth: "90px" }}>
                    <p className="fw-bold">Date</p>
                  </th>
                  <th style={{ minWidth: "80px" }}>
                    <p className="fw-bold">
                      {translations.eventView.table.time[language]}{" "}
                    </p>
                  </th>
                  <th style={{ minWidth: "80px" }}>
                    <p className="fw-bold">
                      {
                        translations.commonWords.usersTypes.representative[
                          language
                        ]
                      }{" "}
                    </p>
                  </th>
                  <th style={{ minWidth: "100px" }}>
                    <p className="fw-bold">
                      {translations.quickCreationModal.state[language]}{" "}
                    </p>
                  </th>
                  <th style={{ minWidth: "100px" }}>
                    <p className="fw-bold">
                      {translations.eventView.table.result[language]}{" "}
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {appointments &&
                  appointments.length > 0 &&
                  appointments.map((data, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {(data?.prospective?.first_name ?? "") +
                          " " +
                          (data?.prospective?.last_name ?? "")}{" "}
                      </td>
                       <td
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {data?.prospective?.prospect_source}{" "}
                      </td>
                      <td
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {data?.prospective?.phone}{" "}
                      </td>
                      <td
                        className=""
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {data?.appointment_date}{" "}
                      </td>
                      <td
                        className=""
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {data?.appointment_time}{" "}
                      </td>
                      <td
                        className=""
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {data.appointment_rep_user_name}{" "}
                      </td>
                      <td
                        className=""
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {data?.confirmation_status}{" "}
                      </td>
                      <td
                        className=""
                        style={{
                          background: `${
                            index % 2 === 0
                              ? isDarkMode
                                ? "#2B3035"
                                : "#F8F9FA"
                              : isDarkMode
                              ? "#343A3F"
                              : "#E9ECEF"
                          }`,
                        }}
                      >
                        {data?.visit_status}{" "}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUp;
